<div class="card card-custom">
    <div class="card-header">
        <div class="card-title">
            <div class="card-label" style="color: red;">
                Almost there
            </div>
        </div>
    </div>
    <div class="form">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    Please fill in the required fields highlighted in red to continue and save the record.
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-flex justify-content-end">
          <button mat-button (click)="close()">Close</button>
        </div>
    </div>
</div>